// Shared executor for bulk actions that fan out over a per-item endpoint, so a
// bulk op can't fire a wall of requests at once. Settles in input order.
export const DEFAULT_BULK_CONCURRENCY = 4;

export async function runWithConcurrency<T, R>(
  items: T[],
  worker: (item: T, index: number) => Promise<R>,
  concurrency: number = DEFAULT_BULK_CONCURRENCY
): Promise<PromiseSettledResult<R>[]> {
  const cap = Math.max(1, concurrency);
  const settled: PromiseSettledResult<R>[] = [];

  for (let i = 0; i < items.length; i += cap) {
    const batch = items.slice(i, i + cap);
    const results = await Promise.allSettled(batch.map((item, j) => worker(item, i + j)));
    settled.push(...results);
  }

  return settled;
}
